import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'

// OBTENER SESIONES MAS RECIENTES
export const getListadoArchivos = async(Codigo) => {
    const respuesta = await PrivateInterceptor(`IT/Test/getTest/` + Codigo, 'GET')
    return respuesta;
}

export const descargarArchivo = async (Codigo, nombre) => {
    const respuesta = await PrivateInterceptor(`IT/Test/getFile/${Codigo}/${nombre}`, 'GET')
    return respuesta;
}

export const eliminarArchivo = async (Codigo, nombre) => {
    const respuesta = await PrivateInterceptor(`IT/Test/deleteFile/${Codigo}/${nombre}`, 'DELETE')
    return respuesta;
}